export const deviceIdKey = '__TOMIS__device_id';
